export default __webpack_public_path__ + "static/noodling-c328326bb17120b92b47d527517bd19e.svg";